module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_winter-0f6a57bf06ef206a754fd7e44c3c187e.webp";